import React from 'react';
import '../styles/AdBanners.css';

// 4 Meta-Ad-ready square banners (1080x1080) for the Parents' Digital Safety Handbook.
// Each renders absolutely and can be screenshotted by its data-testid.
const HERO_PHOTO = 'https://customer-assets.emergentagent.com/job_afd41a96-3db0-4d80-bd81-613b1e97abf0/artifacts/scfx0muq_a-warm-emotionally-resonant-photograph-of-_qfvR0iVASViEMyFFC3KU5g_fzaaAVfdQ8aASW8AhA9bwg.jpeg';
const SHIELD = 'https://customer-assets.emergentagent.com/job_express-checkout-9/artifacts/gw8x19qe_Variant%201_Shield%20Only_Vector%20copy.png';

const AdBanners = () => (
  <div className="adb-wrap">
    <h1 className="adb-screen-only">Meta Ad Banners — Parents' Digital Safety Handbook</h1>
    <p className="adb-screen-only">Each banner is 1080×1080. Capture via the screenshot tool with the data-testid.</p>

    {/* =====================================================
        BANNER 1 — "11pm Worry" — emotional, dark, conversion
        ===================================================== */}
    <div className="adb adb-1" data-testid="adb-1">
      <div className="adb-1-bg" style={{ backgroundImage: `url(${HERO_PHOTO})` }} />
      <div className="adb-1-overlay" />
      <div className="adb-1-content">
        <div className="adb-brand">
          <img src={SHIELD} alt="" />
          <span>From All Secured</span>
        </div>
        <h2 className="adb-1-headline">
          It's 11pm.<br/>Your kid is still<br/>on their phone.
        </h2>
        <p className="adb-1-italic">
          This is the guide every<br/>Australian parent quietly needs.
        </p>
        <div className="adb-1-cta-row">
          <span className="adb-1-cta">Get the Handbook — $9.99 →</span>
        </div>
        <p className="adb-1-foot">36-page PDF · Instant download · Read tonight</p>
      </div>
    </div>

    {/* =====================================================
        BANNER 2 — "6 sources, 1 guide" — authority / distilled
        ===================================================== */}
    <div className="adb adb-2" data-testid="adb-2">
      <div className="adb-2-warm" />
      <div className="adb-2-content">
        <div className="adb-brand adb-brand-dark">
          <img src={SHIELD} alt="" />
          <span>From All Secured</span>
        </div>
        <div className="adb-2-stats">
          <div className="adb-2-stat"><span className="num">6</span><span className="label">trusted<br/>sources</span></div>
          <div className="adb-2-plus">→</div>
          <div className="adb-2-stat"><span className="num">1</span><span className="label">calm<br/>guide</span></div>
        </div>
        <h2 className="adb-2-headline">
          We read every major<br/>Australian source<br/>so you don't have to.
        </h2>
        <div className="adb-2-pills">
          <span>eSafety</span><span>AFP</span><span>ACCCE</span><span>Kids Helpline</span><span>Dolly's Dream</span><span>Telethon Kids</span>
        </div>
        <div className="adb-2-cta-bar">
          <span className="adb-2-product">Parents' Digital Safety Handbook</span>
          <span className="adb-2-cta">Read tonight — $9.99 →</span>
        </div>
      </div>
    </div>

    {/* =====================================================
        BANNER 3 — Family photo, full-bleed cinematic
        ===================================================== */}
    <div className="adb adb-3" data-testid="adb-3">
      <div className="adb-3-bg" style={{ backgroundImage: `url(${HERO_PHOTO})` }} />
      <div className="adb-3-bottom-fade" />
      <div className="adb-3-top-fade" />
      <div className="adb-3-content">
        <div className="adb-brand adb-brand-on-image">
          <img src={SHIELD} alt="" />
          <span>From All Secured</span>
        </div>
        <div className="adb-3-bottom">
          <h2 className="adb-3-headline">
            Raise cyber-safe kids —<br/>without the lectures.
          </h2>
          <p className="adb-3-sub">
            36 pages. Plain English. Written for normal parents.
          </p>
          <div className="adb-3-cta-bar">
            <span className="adb-3-cta">Get the Handbook — $9.99 AUD</span>
          </div>
        </div>
      </div>
    </div>

    {/* =====================================================
        BANNER 4 — Bold stat hook + transformation promise
        ===================================================== */}
    <div className="adb adb-4" data-testid="adb-4">
      <div className="adb-4-content">
        <div className="adb-brand">
          <img src={SHIELD} alt="" />
          <span>From All Secured</span>
        </div>
        <div className="adb-4-eyebrow">If you parent a child online…</div>
        <h2 className="adb-4-headline">
          From <span className="adb-4-strike">overwhelmed</span><br/>to <span className="adb-4-gold">in control</span><br/>— in one weekend read.
        </h2>
        <ul className="adb-4-list">
          <li>The Family Digital Agreement</li>
          <li>Warning signs by age 6, 10, 14</li>
          <li>Real conversation scripts</li>
          <li>What to do if something goes wrong</li>
        </ul>
        <div className="adb-4-cta-row">
          <div className="adb-4-price"><span className="adb-4-currency">A$</span><span className="adb-4-num">9</span><span className="adb-4-cents">.99</span></div>
          <div className="adb-4-cta-stack">
            <span className="adb-4-cta">Get the Handbook →</span>
            <span className="adb-4-foot">Instant PDF · One-time payment</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AdBanners;
